import ReactMarkdown from "react-markdown";

export function EngineeringChangeMarkdown({ children }: { children: string }): JSX.Element {
  return (
    <div className="text-sm">
      <ReactMarkdown
        components={{
          h1: ({ children: heading }) => (
            <h2 className="mb-2 mt-5 text-base font-semibold text-slate-950 first:mt-0">{heading}</h2>
          ),
          h2: ({ children: heading }) => (
            <h2 className="mb-2 mt-5 text-base font-semibold text-slate-950 first:mt-0">{heading}</h2>
          ),
          h3: ({ children: heading }) => (
            <h3 className="mb-1 mt-3 font-semibold text-slate-900">{heading}</h3>
          ),
          p: ({ children: paragraph }) => (
            <p className="my-2 whitespace-pre-wrap leading-6 text-slate-800">{paragraph}</p>
          ),
          ul: ({ children: list }) => (
            <ul className="my-2 list-disc space-y-1 pl-5 text-slate-800">{list}</ul>
          ),
          ol: ({ children: list }) => (
            <ol className="my-2 list-decimal space-y-1 pl-5 text-slate-800">{list}</ol>
          ),
          li: ({ children: item }) => <li className="leading-6">{item}</li>,
          strong: ({ children: strong }) => (
            <strong className="font-semibold text-slate-950">{strong}</strong>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
